import React from "react";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const InviteErrorResult = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Result
      status="error"
      title={t("pages.accept-invite.invite-not-found")}
      subTitle={t("pages.accept-invite.invite-not-found-description")}
      extra={
        <Button onClick={() => navigate("login")}>
          {t("pages.accept-invite.to-login")}
        </Button>
      }
    ></Result>
  );
};
